<template>
  <div :class="classes">
    <div class="row">
      <div class="col-8">
        <div class="dx-card-manage-item__info">
          <h2>
            {{ card.answer }}
            <small :class="classesState">{{ $t(card.state) }}</small>
          </h2>
          <p>
            <span class="badge badge-primary">{{ $t(card.card_level.name) }}</span>
            <span class="badge badge-primary">{{ $t(card.card_type.name) }}</span>
          </p>
          <p>
            <span class="value-type">{{ $t('tips') }}:</span>
            {{ card.card_tips.length }}
          </p>
          <p>
            <span class="value-type">{{ $t('createdAt') }}:</span>
            {{ card.created_at | dateTime }}
          </p>
          <p>
            <span class="value-type">{{ $t('views') }}:</span>
            {{ card.views }}
          </p>
          <p>
            <span class="value-type">{{ $t('upVotes') }}:</span>
            {{ card.up_votes }}
            -
            <span class="value-type">{{ $t('downVotes') }}:</span>
            {{ card.down_votes }}
          </p>
        </div>
      </div>
      <div class="col-4 text-right">
        <dx-button small primary :disabled="disabled" @click.native="$emit('edit', card)">
          <icon name="pencil" />
        </dx-button>
        <dx-button-confirm
          danger
          small
          right
          :disabled="disabled"
          :loading="disabled"
          @click="onDelete"
          >
          <icon name="times" />
        </dx-button-confirm>
      </div>
    </div>
    <hr class="orange-separator">
  </div>
</template>

<script>
import 'vue-awesome/icons/pencil'
import 'vue-awesome/icons/times'
import DxButton from './DxButton.vue'
import DxButtonConfirm from './DxButtonConfirm.vue'

export default {
  name: 'dx-card-manage-item',
  components: {
    DxButton,
    DxButtonConfirm
  },
  props: {
    card: Object
  },
  data () {
    return {
      disabled: false
    }
  },
  computed: {
    classes () {
      return {
        'dx-card-manage-item': true,
        'dx-card-manage-item--active': this.card.state === 'active',
        'dx-card-manage-item--pending': this.card.state === 'pending',
        'dx-card-manage-item--disabled': this.card.state === 'disabled'
      }
    },
    classesState () {
      return {
        'badge': true,
        'badge-success': this.card.state === 'active',
        'badge-secondary': this.card.state === 'pending',
        'badge-danger': this.card.state === 'disabled'
      }
    }
  },
  methods: {
    onDelete () {
      this.$emit('delete', this.card)
      this.disabled = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DxCardManageItem.vue